import { useState } from "react";
import { useTranslation } from "react-i18next";

const ProjectEditInline = ({ title, description, onSave, onCancel }) => {
  const { t } = useTranslation();
  const [editTitle, setEditTitle] = useState(title || "");
  const [editDescription, setEditDescription] = useState(description || "");
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!editTitle.trim()) return;

    setIsSaving(true);
    try {
      await onSave({
        name: editTitle.trim(),
        description: editDescription.trim(),
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-3">
      <div>
        <label
          htmlFor="editTitle"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {t("project_edit.project_title")}{" "}
          <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="editTitle"
          value={editTitle}
          onChange={(e) => setEditTitle(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-lg"
          placeholder={t("project_edit.enter_title")}
        />
      </div>
      <div>
        <label
          htmlFor="editDescription"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {t("project_edit.description")}{" "}
          <span className="text-gray-400 text-xs">
            ({t("project_edit.optional")})
          </span>
        </label>
        <textarea
          id="editDescription"
          rows={3}
          value={editDescription}
          onChange={(e) => setEditDescription(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          placeholder={t("project_edit.enter_description")}
        />
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={handleSave}
          disabled={isSaving || !editTitle.trim()}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-400 disabled:cursor-not-allowed"
        >
          {isSaving ? t("project_edit.saving") : t("project_edit.save")}
        </button>
        <button
          onClick={onCancel}
          disabled={isSaving}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          {t("project_edit.cancel")}
        </button>
      </div>
    </div>
  );
};

export default ProjectEditInline;
